// src/components/Services.js
import React from 'react';
import './Services.css';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <div className="services-section">
      <h2 className="services-title">Our Services</h2>
      <div className="services-content">
        <div className="service-item">
          <div className="service-icon animated-icon">
            <i className="fas fa-shield-alt"></i> {/* Warranty symbol */}
          </div>
          <h3>1 Year Warranty</h3>
          <p>Comprehensive support for a full year.</p>
        </div>
        <div className="service-item">
          <div className="service-icon animated-icon">
            <i className="fas fa-tools"></i> {/* Maintenance tools icon */}
          </div>
          <h3>Maintenance</h3>
          <p>Regular checks to ensure optimal performance.</p>
        </div>
        <div className="service-item">
          <div className="service-icon animated-icon">
            <i className="fas fa-cogs"></i> {/* Gear icon for installation */}
          </div>
          <h3>Installation</h3>
          <p>Expert setup of your systems.</p>
        </div>
        <div className="service-item">
          <div className="service-icon animated-icon">
            <i className="fas fa-headset"></i> {/* Support icon */}
          </div>
          <h3>Customer Support</h3>
          <p>Assistance available 24/7.</p>
        </div>

        {/* New Service Request Section */}
        <Link to="/service-request" className="service-item" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="service-icon animated-icon">
            <i className="fas fa-clipboard-list"></i> {/* Clipboard icon for service request */}
          </div>
          <h3>Service Request</h3>
          <p>Request a service appointment at your convenience.</p>
        </Link>
      </div>
    </div>
  );
};

export default Services;
